var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useParams } from "react-router";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { Form } from "./music-archive";
import { useMusicArchive, useMusicArchiveDetail } from "./music-archive/model";
import { AdminLayout } from "frontend/src/pages/layouts";
import { TabsSkeleton } from "frontend/src/ui/tabs-skeleton";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import { TableSkeleton } from "frontend/src/ui/table-skeleton";
var Page = function (_a) {
    var musicArchive = _a.musicArchive;
    var _b = useMusicArchive(musicArchive), clientId = _b.clientId, actions = _b.actions;
    var _c = __read(React.useState((clientId.value === null ? 'public' : 'private')), 2), musicArchiveType = _c[0], setType = _c[1];
    var passedType = {
        value: musicArchiveType,
        onChange: function (value) {
            if (value == 'public') {
                actions.setPublic.run();
            }
            setType(value);
        }
    };
    var tabs = [
        {
            label: "Архив плейлиста",
            node: (React.createElement(Form, { client: clientId, type: passedType, handlers: {
                    submit: {
                        do: actions.update.run,
                        pending: actions.update.pending,
                    },
                } })),
        },
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true });
};
export var EditMusicArchivePage = function () {
    var id = useParams().id;
    var _a = useMusicArchiveDetail(Number(id)), musicArchive = _a.musicArchive, remove = _a.remove;
    React.useEffect(function () {
        return remove;
    }, []);
    return (React.createElement(AdminLayout, null, !musicArchive ? (React.createElement(TabsSkeleton, null,
        React.createElement(Skeleton, { variant: "rect", height: 200, width: "100%" }),
        React.createElement(Box, { mt: 1 },
            React.createElement(TableSkeleton, { rows: 25, columns: 6 })))) : (React.createElement(Page, { musicArchive: musicArchive }))));
};
